import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#404040] text-white"
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-8 py-12 md:py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 md:gap-6 text-center md:text-left">
          {/* Logo */}
          <div className="flex justify-center md:justify-start">
            <Logo light size="text-2xl" />
          </div>

          {/* Center links */}
          <nav className="flex flex-col md:flex-row items-center gap-4 md:gap-7 text-[15px]">
            <Link
              data-testid="footer-percorso-link"
              to="/percorso"
              className="text-white/70 hover:text-white transition-colors duration-200"
            >
              Il percorso ValutaGenio
            </Link>
            <Link
              data-testid="footer-perche-vg-link"
              to="/perche-vg"
              className="text-white/70 hover:text-white transition-colors duration-200"
            >
              Perché ValutaGenio
            </Link>
            <Link
              data-testid="footer-privacy-link"
              to="/privacy"
              className="text-white/70 hover:text-white transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <Link
              data-testid="footer-cookie-link"
              to="/cookie"
              className="text-white/70 hover:text-white transition-colors duration-200"
            >
              Cookie Policy
            </Link>
            <a
              data-testid="footer-pa-login-link"
              href="/login"
              className="text-white/70 hover:text-white transition-colors duration-200"
            >
              PA Log-in
            </a>
          </nav>

          {/* Email */}
          <a
            data-testid="footer-email"
            href="mailto:info@valutagenio.com"
            className="text-white/85 hover:text-white text-[15px] font-medium transition-colors duration-200"
          >
            info@valutagenio.com
          </a>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 text-center text-white/55 text-sm">
          © 2026 ValutaGenio. Tutti i diritti riservati.
        </div>
      </div>
    </footer>
  );
}
